<template>
    <SystemDelegation />
</template>

<script>
import SystemDelegation from '@/components/SystemDelegation.vue';
	export default {
		name: 'Delegations',
        components: { SystemDelegation },
        data () {
            return {}
        },
	}
</script>